import React from 'react';
import PropTypes from 'prop-types';
import CallReasons from '../CallReasons';
import SurveyCallInformation from '../SurveyCallInformation';
import SurveyCallBackTasks from '../SurveyCallBackTasks';
import AdditionalDetails from '../AdditionalDetails';
import SurveySummary from '../SurveySummary';
import SurveyComplete from '../SurveyComplete';
import remoteConfigManager from '../../../utils/remote-config-manager';

const Survey = props => {
  const next = e => {
    e.preventDefault();
    props.setStep(props.step + 1);
  };

  const back = e => {
    e.preventDefault();
    props.setStep(props.step - 1);
  };

  const summaryBack = e => {
    e.preventDefault();
    props.setStep(props.step - 1);
  };

  const submit = async e => {
    const responses = props.surveyResponses.find(
      response => response.contactId === props.contactAttributes.contactId
    ).responses;
    e.preventDefault();
    console.log('Complete');
    const word = props.generalDetails.claim.split('NTN');
    const shortClaimId = "NTN"+word[1];
    responses.generalDetails.claim = shortClaimId;
    const surveyResults = {
      contactId: props.contactAttributes.contactId,
      phoneNumber: props.contactAttributes.typeId,
      generalDetails: { ...responses.generalDetails },
      callReasons: [...responses.callReasons],
      primaryCallReason: responses.primaryCallReason,
      taskDetails: { ...responses.taskDetails },
      additionalDetails: responses.additionalDetails,
      displayedOther: responses.displayedOther,
    };
    if (surveyResults.primaryCallReason.toLowerCase().includes('other')) {
      surveyResults.primaryCallReason = surveyResults.primaryCallReason + ' - ' + responses.notes
      surveyResults.primaryCallReason;
    }
    let i = 0;
    for (i = 0; i < surveyResults.callReasons.length; i++) {
      if (surveyResults.callReasons[i].toLowerCase().includes('other')) {
        surveyResults.callReasons[i] = surveyResults.callReasons[i].substring(6,) + ' - ' + props.addNotesList[i].substring(6,)
        surveyResults.callReasons[i];
      } else {
        surveyResults.callReasons[i] = surveyResults.callReasons[i].substring(6,)
        surveyResults.callReasons[i];
      }
    }
    console.log('Summary: ' + JSON.stringify(surveyResults));
    props.setStep(props.step + 1);
    await remoteConfigManager.storeSurvey(surveyResults);
  };

  const handleGeneralDetailsChange = event => {
    const tempGeneralDetails = props.generalDetails;
    tempGeneralDetails[event.target.name] = event.target.value;
    props.setGeneralDetails({ ...tempGeneralDetails });
  };

  const handleTaskDetailsChange = event => {
    props.setTaskDetails({
      ...props.taskDetails,
      [event.target.name]: event.target.value
    });
  };

  const handleCallReasonChange = callReasonValue => {
    if (props.surveyCallReasonValues.includes(callReasonValue)) {
      props.setSurveyCallReasonValues(
        props.surveyCallReasonValues.filter(val => val !== callReasonValue)
      );
    } else {
      props.setSurveyCallReasonValues(props.surveyCallReasonValues.filter(val => !val.includes(callReasonValue.substring(0, 5))));
      props.setSurveyCallReasonValues(prevReasons => [
        ...prevReasons,
        callReasonValue
      ]);
    }
  };

  const removeCallReason = id => {
    props.setSurveyCallReasonValues(props.surveyCallReasonValues.filter(val => !val.includes(id)))
  }

  const handlePrimaryCallReasonChange = selectedPrimaryCallReason => {
    props.setPrimaryCallReason(selectedPrimaryCallReason);
  };

  const getCallInfoComponent = () => {
    return (
      <SurveyCallInformation
        contactAttributes={props.contactAttributes}
        generalDetails={
          props.surveyResponses.find(
            response => response.contactId === props.contactAttributes.contactId
          ).responses.generalDetails
        }
        callerTypeOptions={props.callerTypeOptions}
        handleGeneralDetailsChange={handleGeneralDetailsChange}
        requestTypeOptions={props.requestTypeOptions}
        workItemTypeOptions={props.workItemTypeOptions}
        caseIds={
          props.caseIds.length > 0
            ? props.caseIds.find(
                c => c.contactId === props.contactAttributes.contactId
              ) !== undefined
              ? props.caseIds.find(
                  c => c.contactId === props.contactAttributes.contactId
                ).caseIds
              : []
            : []
        }
        surveyResponses={props.surveyResponses}
        next={next}
      />
    );
  };

  const getCallBackTasksComponent = () => {
    return (
      <SurveyCallBackTasks
        back={back}
        next={next}
        contactAttributes={props.contactAttributes}
        taskDetails={props.taskDetails}
        handleTaskDetailsChange={handleTaskDetailsChange}
      />
    );
  };

  const getCallReasonsComponent = () => {
    return (
      <CallReasons 
        back={back}
        next={next}
        contactAttributes={props.contactAttributes}
        surveyCallReasonValues={props.surveyCallReasonValues}
        handleCallReasonChange={handleCallReasonChange}
        calls={props.calls}
        chats={props.chats}
        failureTask={props.failureTask}
        callbackTask={props.callbackTask}
        intermittentAbsenceTask={props.intermittentAbsenceTask}
        primaryCallReason={
          props.surveyResponses.find(
            response => response.contactId === props.contactAttributes.contactId
          ).responses.primaryCallReason
        }
        handlePrimaryCallReasonChange={handlePrimaryCallReasonChange}
        inputList={props.inputList}
        addNotesList={props.addNotesList}
        setAddNotesList={props.setAddNotesList}
        setInputList={props.setInputList}
        selected={props.selected}
        setSelected={props.setSelected}
        removeCallReason={removeCallReason}
        notes={props.notes}
        setNotes={props.setNotes}
      />
    );
  };

  const getAdditionalDetailsComponent = () => {
    return (
      <AdditionalDetails
        additionalDetails={props.additionalDetails}
        setAdditionalDetails={props.setAdditionalDetails}
        summaryBack={summaryBack}
        back={back}
        next={next}
        setStep={props.setStep}
      />
    );
  }

  const getSurveySummaryComponent = () => {
    const responses = props.surveyResponses.find(
      response => response.contactId === props.contactAttributes.contactId
    ).responses;
    return (
      <SurveySummary
        contactAttributes={props.contactAttributes}
        generalDetails={responses.generalDetails}
        primaryCallReason={responses.primaryCallReason}
        callReasons={responses.callReasons}
        note={responses.note}
        taskDetails={responses.taskDetails}
        summaryBack={summaryBack}
        back={back}
        submit={submit}
        setStep={props.setStep}
        additionalDetails={props.additionalDetails}
        notes={props.notes}
        addNotesList={props.addNotesList}
      />
    );
  };

  const getSurveyCompleteComponent = () => {
    return (
      <SurveyComplete
        submitted={props.submitted}
        setSubmitted={props.setSubmitted}
      />
    )
  };

  const getSurveyComponent = () => {
    if (props.contactAttributes.typeId === 'Task') {
      if (
        props.contactAttributes.callReason &&
        props.contactAttributes.callReason.value !== ''
      ) {
        switch (props.step) {
          case 1:
            if (props.submitted) {
              return getSurveyCompleteComponent();
            } else {
              return getCallInfoComponent();
            }
          case 2:
            return getCallBackTasksComponent();
          case 3:
            return getCallReasonsComponent();
          case 4:
            return getAdditionalDetailsComponent();
          case 5:
            return getSurveySummaryComponent();
          case 6:
            return getSurveyCompleteComponent();
          default:
            return getCallInfoComponent();
        }
      } else if (props.contactAttributes.msgType) {
        switch (props.step) {
          case 1:
            if (props.submitted) {
              return getSurveyCompleteComponent();
            } else {
              return getCallInfoComponent();
            }
          case 2:
            return getCallReasonsComponent();
          case 3:
            return getAdditionalDetailsComponent();
          case 4:
            return getSurveySummaryComponent();
          case 5:
            return getSurveyCompleteComponent();
          default:
            return getCallInfoComponent();
        }
      } else if (props.contactAttributes.absenceBeginTime) {
        switch (props.step) {
          case 1:
            if (props.submitted) {
              return getSurveyCompleteComponent();
            } else {
              return getCallInfoComponent();
            }
          case 2:
            return getCallReasonsComponent();
          case 3:
              return getAdditionalDetailsComponent();
          case 4:
            return getSurveySummaryComponent();
          case 5:
            return getSurveyCompleteComponent();
          default:
            return getCallInfoComponent();
        }
      }
    } else {
      switch (props.step) {
        case 1:
          if (props.submitted) {
              return getSurveyCompleteComponent();
            } else {
              return getCallInfoComponent();
            }
        case 2:
          return getCallReasonsComponent();
        case 3:
          return getAdditionalDetailsComponent();
        case 4:
          return getSurveySummaryComponent();
        case 5:
          return getSurveyCompleteComponent();
        default:
          return getCallInfoComponent();
      }
    }
  };
  return <div id="survey">{getSurveyComponent()}</div>;
};

Survey.propTypes = {
  step: PropTypes.number.isRequired,
  setStep: PropTypes.func.isRequired,
  contactAttributes: PropTypes.shape({
    contactId: PropTypes.string,
    typeId: PropTypes.string,
    callReason: PropTypes.shape({
      value: PropTypes.string,
    }),
    msgType: PropTypes.string,
    absenceBeginTime: PropTypes.string,
  }).isRequired,
  generalDetails: PropTypes.shape({
    claim: PropTypes.string,
  }).isRequired,
  setGeneralDetails: PropTypes.func.isRequired,
  surveyCallReasonValues: PropTypes.array.isRequired,
  setSurveyCallReasonValues: PropTypes.func.isRequired,
  note: PropTypes.string,
  setNote: PropTypes.func.isRequired,
  primaryCallReason: PropTypes.string,
  setPrimaryCallReason: PropTypes.func.isRequired,
  calls: PropTypes.object,
  chats: PropTypes.object,
  failureTask: PropTypes.object,
  callbackTask: PropTypes.object,
  intermittentAbsenceTask: PropTypes.object,
  requestTypeOptions: PropTypes.array,
  workItemTypeOptions: PropTypes.array,
  callerTypeOptions: PropTypes.array,
  caseIds: PropTypes.array,
  taskDetails: PropTypes.object.isRequired,
  setTaskDetails: PropTypes.func.isRequired,
  surveyResponses: PropTypes.arrayOf(PropTypes.shape({
    contactId: PropTypes.string,
    responses: PropTypes.shape({
      generalDetails: PropTypes.object,
      callReasons: PropTypes.array,
      primaryCallReason: PropTypes.string,
      taskDetails: PropTypes.object,
      note: PropTypes.string,
      additionalDetails: PropTypes.string,
      notes: PropTypes.string,
      addNotesList: PropTypes.array,
      inputList: PropTypes.array,
      selected: PropTypes.string,
      submitted: PropTypes.bool,
    }),
  })).isRequired,
  setAdditionalDetails: PropTypes.func.isRequired,
  additionalDetails: PropTypes.string,
  setNotes: PropTypes.func.isRequired,
  notes: PropTypes.string,
  setInputList: PropTypes.func.isRequired,
  inputList: PropTypes.array,
  setAddNotesList: PropTypes.func.isRequired,
  addNotesList: PropTypes.array,
  selected: PropTypes.string,
  setSelected: PropTypes.func.isRequired,
  submitted: PropTypes.bool,
  setSubmitted: PropTypes.func.isRequired,
};

export default Survey;
